import { render, staticRenderFns } from "./BaseTemplate.vue?vue&type=template&id=5b6e5125&scoped=true&"
import script from "./BaseTemplate.vue?vue&type=script&lang=js&"
export * from "./BaseTemplate.vue?vue&type=script&lang=js&"
import style0 from "./BaseTemplate.vue?vue&type=style&index=0&id=5b6e5125&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6e5125",
  null
  
)

export default component.exports